<div class="app-container">
  <loading-spinner
    [isLoading]="queryCompanyCarrier.isPending() || queryCompanyCarrier.isPending() || queryCompanyCarrier.isLoading()"
    [classesString]="'top-50'"
  ></loading-spinner>
  @if (
    isCreating() ||
    (!isCreating() &&
      !this.queryCompanyCarrier.isPending() &&
      !this.queryCompanyCarrier.isLoading() &&
      !this.queryCompanyCarrier.isFetching())
  ) {
    <form [formGroup]="companyCarrierForm" (ngSubmit)="submitCarrier()">
      <page-header
        [title]="isCreating() ? 'companyCarrier.new' : ''"
        [appendNoTranslationTitlePart]="isCreating() ? '' : queryCompanyCarrier.data()?.name"
        [icon]="'far-envelope'"
      >
        <ng-container class="header-button">
          <btn
            [label]="'save'"
            [title]="'save' | translate"
            [classes]="['btn-first', 'float-right']"
            [icon]="'far-check'"
            [btnType]="'submit'"
            [btnDisabled]="companyCarrierForm.invalid || loading()"
            [isLoading]="loading()"
            [spinnerClassesString]="'spinner-white'"
            [dataCyAttribute]="'create-carrier'"
          ></btn>
          @if (!isCreating()) {
            <btn
              [label]="'delete'"
              [title]="'delete' | translate"
              [classes]="['btn-first-red', 'float-right', isCreating() ? '' : 'me-2']"
              [icon]="'far-trash-alt'"
              [btnType]="'button'"
              (onEvent)="confirmDeleteCarrier()"
              [dataCyAttribute]="'delete-carrier'"
            ></btn>
          }
        </ng-container>
        <ng-container class="back-button">
          <btn
            [label]="'back'"
            [title]="'back' | translate"
            [isBackButton]="true"
            [classes]="['btn-third', 'float-right', 'me-2']"
            [icon]="'far-arrow-left'"
            (onEvent)="goBack()"
          ></btn>
        </ng-container>
      </page-header>
      <section class="content">
        @if (testResult(); as result) {
          <div
            role="alert"
            class="alert"
            [class.alert-success]="result.success"
            [class.alert-danger]="!result.success"
            data-cy="carrier-test-result"
          >
            <button
              type="button"
              class="btn-close float-end"
              [attr.aria-label]="'close' | translate"
              (click)="testResult.set(null)"
            ></button>
            <strong>{{
              (result.success ? 'company-carrier.test.success' : 'company-carrier.test.failure') | translate
            }}</strong>
            @if (result.testMode) {
              ({{ 'company-carrier.test.test-mode' | translate }})
            }
            @if (result.status) {
              <div>{{ 'company-carrier.test.status' | translate }}: {{ result.status }}</div>
            }
            @if (result.message) {
              <div>{{ result.message }}</div>
            }
            @if (result.missingOptions.length) {
              <div>
                {{ 'company-carrier.test.missing-options' | translate }}: {{ result.missingOptions.join(', ') }}
              </div>
            }
            @if (result.shipmentTested) {
              <div>
                {{ 'company-carrier.test.shipment-tested' | translate: { number: result.shipmentNumber } }}
              </div>
            }
          </div>
        }
        <div class="card">
          <div class="row">
            @if (!!companyCarrierForm.value) {
              <div class="col-sm-6">
                <form-row-select
                  [label]="'carrier'"
                  [icon]="null"
                  [formGroup]="companyCarrierForm"
                  formControlName="carrier"
                  [options]="queryCarriersOptions.data()"
                  [dataCyAttribute]="'companyCarrier-carrier'"
                ></form-row-select>
                <form-row-select
                  [label]="'checkout'"
                  [icon]="null"
                  [formGroup]="companyCarrierForm"
                  formControlName="checkout"
                  [options]="queryCheckoutsOptions.data()"
                  [dataCyAttribute]="'companyCarrier-checkout'"
                ></form-row-select>
                <p style="color: red; font-size: 10px; width: 70%">
                  {{ 'companyCarrier.checkout.note' | translate }}
                </p>
                <form-row-checkbox
                  [formGroup]="companyCarrierForm"
                  [label]="'enable'"
                  formControlName="enable"
                  [dataCySelector]="'companyCarrier-enable'"
                ></form-row-checkbox>
              </div>
            }
            @if (hasOptionsObjAnyKeys() || companyCarrierForm.value.carrier === 'ppl') {
              <div class="flex-gap-10 flex-column col-sm-6">
                <div class="d-flex justify-content-between align-items-center gap-2">
                  <h3 class="card-title mb-0">{{ 'carrier.api.settings' | translate }}</h3>
                  @if (!isCreating()) {
                    <btn
                      [label]="'company-carrier.test.button'"
                      [title]="'company-carrier.test.button' | translate"
                      [classes]="['btn-second']"
                      [icon]="'far-exchange'"
                      [btnType]="'button'"
                      [btnDisabled]="loading() || testCompanyCarrier.isPending()"
                      [isLoading]="testCompanyCarrier.isPending()"
                      (onEvent)="runCarrierTest()"
                      [dataCyAttribute]="'test-carrier'"
                    ></btn>
                  }
                </div>
                @if (
                  companyCarrierForm.value.carrier === 'cp' ||
                  companyCarrierForm.value.carrier === 'cp_np' ||
                  companyCarrierForm.value.carrier === 'cp_nb' ||
                  companyCarrierForm.value.carrier === 'cp_bn'
                ) {
                  <div>
                    <form-row-input
                      [label]="'carrier.customerId'"
                      [icon]="null"
                      [model]="cpSetting().customerID"
                      (modelChange)="settingsChanged($event, 'customerID', cpSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'carrier.contractNumber'"
                      [icon]="null"
                      [model]="cpSetting().contractNumber"
                      (modelChange)="settingsChanged($event, 'contractNumber', cpSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'carrier.postCode'"
                      [icon]="null"
                      [model]="cpSetting().postCode"
                      (modelChange)="settingsChanged($event, 'postCode', cpSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'carrier.locationNumber'"
                      [icon]="null"
                      [model]="cpSetting().locationNumber"
                      (modelChange)="settingsChanged($event, 'locationNumber', cpSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'carrier.apiToken'"
                      [icon]="null"
                      [model]="cpSetting().apiToken"
                      (modelChange)="settingsChanged($event, 'apiToken', cpSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'carrier.apiSecret'"
                      [icon]="null"
                      [model]="cpSetting().apiSecret"
                      (modelChange)="settingsChanged($event, 'apiSecret', cpSetting)"
                    ></form-row-input>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'dhl_express') {
                  <div>
                    <form-row-input
                      [label]="'username'"
                      [icon]="null"
                      [model]="dhlExpressSetting().username"
                      (modelChange)="settingsChanged($event, 'username', dhlExpressSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'password'"
                      [icon]="null"
                      [model]="dhlExpressSetting().password"
                      (modelChange)="settingsChanged($event, 'password', dhlExpressSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'carrier.accountNumber'"
                      [icon]="null"
                      (modelChange)="settingsChanged($event, 'account_number', dhlExpressSetting)"
                      [model]="dhlExpressSetting().account_number"
                    ></form-row-input>
                    <form-row-input
                      [label]="'carrier.contentDescription'"
                      [icon]="null"
                      [model]="dhlExpressSetting().content_description"
                      (modelChange)="settingsChanged($event, 'content_description', dhlExpressSetting)"
                    ></form-row-input>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'dpd') {
                  <div>
                    <div class="padding-bottom-0-5">
                      <form-row-select
                        [icon]="null"
                        [model]="selectedDpdOption()"
                        (modelChange)="selectedDpdChanged($event)"
                        [options]="dpdOptions"
                        [dataCyAttribute]="'isDpdRestSelect'"
                      ></form-row-select>
                    </div>
                    @if (selectedDpdOption() === 'oldDpd') {
                      <form-row-input
                        [label]="'carrier.customerId'"
                        [icon]="null"
                        [model]="oldDpdSetting().customerId"
                        (modelChange)="settingsChanged($event, 'customerId', oldDpdSetting)"
                        [dataCyAttribute]="'companyCarrier-dpd-customerId'"
                      ></form-row-input>
                      <form-row-input
                        [label]="'carrier.customerAddressId'"
                        [icon]="null"
                        [model]="oldDpdSetting().customerAddressId"
                        (modelChange)="settingsChanged($event, 'customerAddressId', oldDpdSetting)"
                        [dataCyAttribute]="'companyCarrier-dpd-customerAddressId'"
                      ></form-row-input>
                      <form-row-input
                        [label]="'username'"
                        [icon]="null"
                        [model]="oldDpdSetting().username"
                        (modelChange)="settingsChanged($event, 'username', oldDpdSetting)"
                        [dataCyAttribute]="'companyCarrier-dpd-username'"
                      ></form-row-input>
                      <form-row-input
                        [label]="'password'"
                        [icon]="null"
                        [model]="oldDpdSetting().password"
                        (modelChange)="settingsChanged($event, 'password', oldDpdSetting)"
                        [dataCyAttribute]="'companyCarrier-dpd-password'"
                      ></form-row-input>
                    }
                    @if (selectedDpdOption() === 'newDpd') {
                      <form-row-input
                        [label]="'carrier.apiKey'"
                        [required]="true"
                        [requiredCssClass]="submitted() && !newDpdSetting().apiKey"
                        [icon]="null"
                        [model]="newDpdSetting().apiKey"
                        (modelChange)="settingsChanged($event, 'apiKey', newDpdSetting)"
                        [dataCyAttribute]="'companyCarrier-dpd-apiKey'"
                      ></form-row-input>
                      <form-row-input
                        [label]="'carrier.apiKeyTest'"
                        [icon]="null"
                        [model]="newDpdSetting().apiKeyTest"
                        (modelChange)="settingsChanged($event, 'apiKeyTest', newDpdSetting)"
                        [dataCyAttribute]="'companyCarrier-dpd-apiKeyTest'"
                      ></form-row-input>
                      <form-row-input
                        [label]="'carrier.customerDsw'"
                        [required]="true"
                        [requiredCssClass]="submitted() && !newDpdSetting().customerDsw"
                        [icon]="null"
                        [model]="newDpdSetting().customerDsw"
                        (modelChange)="settingsChanged($event, 'customerDsw', newDpdSetting)"
                        [dataCyAttribute]="'companyCarrier-dpd-customerDsw'"
                      ></form-row-input>
                      <form-row-input
                        [label]="'carrier.customerAddressId'"
                        [required]="true"
                        [requiredCssClass]="submitted() && !newDpdSetting().customerAddressIt4emId"
                        [icon]="null"
                        [model]="newDpdSetting().customerAddressIt4emId"
                        (modelChange)="settingsChanged($event, 'customerAddressIt4emId', newDpdSetting)"
                        [dataCyAttribute]="'companyCarrier-dpd-customerAddressIt4emId'"
                      ></form-row-input>
                      <form-row-checkbox
                        [label]="'carrier.notificationPredict'"
                        [model]="newDpdSetting().notification"
                        (modelChange)="settingsChanged($event, 'notification', newDpdSetting)"
                        [dataCySelector]="'companyCarrier-dpd-notification'"
                      ></form-row-checkbox>
                      <form-row-checkbox
                        [label]="'carrier.insurance'"
                        [model]="newDpdSetting().insurance"
                        (modelChange)="settingsChanged($event, 'insurance', newDpdSetting)"
                        [dataCySelector]="'companyCarrier-dpd-insurance'"
                      ></form-row-checkbox>
                      <form-row-select
                        [label]="'carrier.codPayment'"
                        [icon]="null"
                        [model]="newDpdSetting().codPayment"
                        (modelChange)="settingsChanged($event, 'codPayment', newDpdSetting)"
                        [options]="dpdCodPaymentOptions"
                        [dataCyAttribute]="'companyCarrier-dpd-codPayment'"
                      ></form-row-select>
                    }
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'one') {
                  <div>
                    <form-row-input
                      [label]="'carrier.apiKey'"
                      [required]="true"
                      [requiredCssClass]="submitted() && !oneSetting().apiKey"
                      [icon]="null"
                      [model]="oneSetting().apiKey"
                      (modelChange)="settingsChanged($event, 'apiKey', oneSetting)"
                      [dataCyAttribute]="'companyCarrier-one-apiKey'"
                    ></form-row-input>
                    <form-row-input
                      [label]="'password'"
                      [required]="true"
                      [requiredCssClass]="submitted() && !oneSetting().password"
                      [inputType]="'password'"
                      [icon]="null"
                      [model]="oneSetting().password"
                      (modelChange)="settingsChanged($event, 'password', oneSetting)"
                      [dataCyAttribute]="'companyCarrier-one-password'"
                    ></form-row-input>
                    <button
                      type="button"
                      class="btn btn-link d-flex align-items-center gap-2 p-0 mb-2 text-start"
                      (click)="toggleOneSender()"
                      [attr.aria-expanded]="oneSenderExpanded()"
                      aria-controls="one-sender-address"
                      data-cy="companyCarrier-one-sender-toggle"
                    >
                      <i class="far fa-chevron-down" [ngClass]="{ rotate: oneSenderExpanded() }"></i>
                      {{ 'carrier.one.senderAddress' | translate }}
                    </button>
                    @if (oneSenderExpanded()) {
                      <div
                        id="one-sender-address"
                        role="group"
                        [attr.aria-label]="'carrier.one.senderAddress' | translate"
                        data-cy="companyCarrier-one-sender"
                      >
                        <p class="text-muted small">{{ 'carrier.one.senderAddress.help' | translate }}</p>
                        <form-row-input
                          [label]="'company.name'"
                          [icon]="null"
                          [model]="oneSetting().senderCompanyName"
                          (modelChange)="settingsChanged($event, 'senderCompanyName', oneSetting)"
                          [dataCyAttribute]="'companyCarrier-one-senderCompanyName'"
                        ></form-row-input>
                        <div class="row">
                          <div class="col-sm-6">
                            <form-row-input
                              [label]="'firstName'"
                              [icon]="null"
                              [model]="oneSetting().senderFirstName"
                              (modelChange)="settingsChanged($event, 'senderFirstName', oneSetting)"
                              [dataCyAttribute]="'companyCarrier-one-senderFirstName'"
                            ></form-row-input>
                          </div>
                          <div class="col-sm-6">
                            <form-row-input
                              [label]="'lastName'"
                              [icon]="null"
                              [model]="oneSetting().senderLastName"
                              (modelChange)="settingsChanged($event, 'senderLastName', oneSetting)"
                              [dataCyAttribute]="'companyCarrier-one-senderLastName'"
                            ></form-row-input>
                          </div>
                        </div>
                        <form-row-input
                          [label]="'carrier.one.street'"
                          [icon]="null"
                          [model]="oneSetting().senderStreet"
                          (modelChange)="settingsChanged($event, 'senderStreet', oneSetting)"
                          [dataCyAttribute]="'companyCarrier-one-senderStreet'"
                        ></form-row-input>
                        <div class="row">
                          <div class="col-sm-6">
                            <form-row-input
                              [label]="'carrier.one.streetNumber'"
                              [icon]="null"
                              [model]="oneSetting().senderStreetNumber"
                              (modelChange)="settingsChanged($event, 'senderStreetNumber', oneSetting)"
                              [dataCyAttribute]="'companyCarrier-one-senderStreetNumber'"
                            ></form-row-input>
                          </div>
                          <div class="col-sm-6">
                            <form-row-input
                              [label]="'carrier.one.flatNumber'"
                              [icon]="null"
                              [model]="oneSetting().senderFlatNumber"
                              (modelChange)="settingsChanged($event, 'senderFlatNumber', oneSetting)"
                              [dataCyAttribute]="'companyCarrier-one-senderFlatNumber'"
                            ></form-row-input>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-8">
                            <form-row-input
                              [label]="'city'"
                              [icon]="null"
                              [model]="oneSetting().senderCity"
                              (modelChange)="settingsChanged($event, 'senderCity', oneSetting)"
                              [dataCyAttribute]="'companyCarrier-one-senderCity'"
                            ></form-row-input>
                          </div>
                          <div class="col-sm-4">
                            <form-row-input
                              [label]="'zip'"
                              [icon]="null"
                              [model]="oneSetting().senderZip"
                              (modelChange)="settingsChanged($event, 'senderZip', oneSetting)"
                              [dataCyAttribute]="'companyCarrier-one-senderZip'"
                            ></form-row-input>
                          </div>
                        </div>
                        <form-row-select
                          [label]="'country'"
                          [icon]="null"
                          [model]="oneSetting().senderCountry"
                          (modelChange)="settingsChanged($event, 'senderCountry', oneSetting)"
                          [options]="oneSenderCountryOptions"
                          [optionKey]="'code'"
                          [dataCyAttribute]="'companyCarrier-one-senderCountry'"
                        ></form-row-select>
                        <div class="row">
                          <div class="col-sm-6">
                            <form-row-input
                              [label]="'phone'"
                              [icon]="null"
                              [model]="oneSetting().senderPhone"
                              (modelChange)="settingsChanged($event, 'senderPhone', oneSetting)"
                              [dataCyAttribute]="'companyCarrier-one-senderPhone'"
                            ></form-row-input>
                          </div>
                          <div class="col-sm-6">
                            <form-row-input
                              [label]="'email'"
                              [inputType]="'email'"
                              [icon]="null"
                              [model]="oneSetting().senderEmail"
                              (modelChange)="settingsChanged($event, 'senderEmail', oneSetting)"
                              [dataCyAttribute]="'companyCarrier-one-senderEmail'"
                            ></form-row-input>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'dpd_sk') {
                  <div>
                    <form-row-input
                      [label]="'carrier.customerId'"
                      [icon]="null"
                      [model]="dpdSkSetting().customerId"
                      (modelChange)="settingsChanged($event, 'customerId', dpdSkSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'carrier.customerAddressId'"
                      [icon]="null"
                      [model]="dpdSkSetting().customerAddressId"
                      (modelChange)="settingsChanged($event, 'customerAddressId', dpdSkSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'email'"
                      [icon]="null"
                      [model]="dpdSkSetting().email"
                      (modelChange)="settingsChanged($event, 'email', dpdSkSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'carrier.apiKey'"
                      [icon]="null"
                      [model]="dpdSkSetting().apiKey"
                      (modelChange)="settingsChanged($event, 'apiKey', dpdSkSetting)"
                    ></form-row-input>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'fedex') {
                  <div>
                    <div
                      role="group"
                      [attr.aria-label]="'carrier.fedex.production' | translate"
                      data-cy="companyCarrier-fedex-production"
                    >
                      <h4 class="settings-group-title">{{ 'carrier.fedex.production' | translate }}</h4>
                      <form-row-input
                        [label]="'carrier.fedex.clientId'"
                        [required]="true"
                        [requiredCssClass]="submitted() && isFedexCredentialMissing(fedexSetting().clientId)"
                        [icon]="null"
                        [model]="fedexSetting().clientId"
                        [tooltipLabel]="'carrier.fedex.clientId.hint'"
                        (modelChange)="settingsChanged($event, 'clientId', fedexSetting)"
                        [dataCyAttribute]="'companyCarrier-fedex-clientId'"
                      ></form-row-input>
                      <form-row-input
                        [label]="'carrier.fedex.clientSecret'"
                        [required]="true"
                        [requiredCssClass]="submitted() && isFedexCredentialMissing(fedexSetting().clientSecret)"
                        [icon]="null"
                        [model]="fedexSetting().clientSecret"
                        (modelChange)="settingsChanged($event, 'clientSecret', fedexSetting)"
                        [dataCyAttribute]="'companyCarrier-fedex-clientSecret'"
                      ></form-row-input>
                      <form-row-digits
                        [label]="'carrier.fedex.accountNumber'"
                        [required]="true"
                        [requiredCssClass]="
                          isFedexAccountNumberFormatInvalid(fedexSetting().accountNumber) ||
                          (submitted() && isFedexCredentialMissing(fedexSetting().accountNumber))
                        "
                        [model]="fedexSetting().accountNumber"
                        (modelChange)="settingsChanged($event, 'accountNumber', fedexSetting)"
                        [tooltipLabel]="'carrier.fedex.accountNumber.hint'"
                        [errorLabel]="
                          isFedexAccountNumberFormatInvalid(fedexSetting().accountNumber)
                            ? 'carrier.fedex.accountNumber.invalid'
                            : null
                        "
                        [dataCyAttribute]="'companyCarrier-fedex-accountNumber'"
                      ></form-row-digits>
                      <div
                        class="settings-subsection"
                        role="group"
                        [attr.aria-label]="'carrier.fedex.track' | translate"
                        data-cy="companyCarrier-fedex-track"
                      >
                        <p class="font-weight-bold mb-1">{{ 'carrier.fedex.track' | translate }}</p>
                        <p class="text-muted small">{{ 'carrier.fedex.track.hint' | translate }}</p>
                        <form-row-input
                          [label]="'carrier.fedex.trackClientId'"
                          [requiredCssClass]="
                            submitted() &&
                            !isFedexTrackPairValid(fedexSetting().trackClientId, fedexSetting().trackClientSecret)
                          "
                          [icon]="null"
                          [model]="fedexSetting().trackClientId"
                          (modelChange)="settingsChanged($event, 'trackClientId', fedexSetting)"
                          [dataCyAttribute]="'companyCarrier-fedex-trackClientId'"
                        ></form-row-input>
                        <form-row-input
                          [label]="'carrier.fedex.trackClientSecret'"
                          [requiredCssClass]="
                            submitted() &&
                            !isFedexTrackPairValid(fedexSetting().trackClientId, fedexSetting().trackClientSecret)
                          "
                          [icon]="null"
                          [model]="fedexSetting().trackClientSecret"
                          (modelChange)="settingsChanged($event, 'trackClientSecret', fedexSetting)"
                          [dataCyAttribute]="'companyCarrier-fedex-trackClientSecret'"
                        ></form-row-input>
                      </div>
                    </div>
                    <div
                      role="group"
                      [attr.aria-label]="'carrier.fedex.testData' | translate"
                      data-cy="companyCarrier-fedex-testData"
                    >
                      <h4 class="settings-group-title">{{ 'carrier.fedex.testData' | translate }}</h4>
                      <div
                        class="settings-subsection"
                        role="group"
                        [attr.aria-label]="'carrier.fedex.sandbox' | translate"
                        data-cy="companyCarrier-fedex-sandbox"
                      >
                        <p class="font-weight-bold mb-1">{{ 'carrier.fedex.sandbox' | translate }}</p>
                        <form-row-input
                          [label]="'carrier.fedex.clientIdTest'"
                          [icon]="null"
                          [model]="fedexSetting().clientIdTest"
                          (modelChange)="settingsChanged($event, 'clientIdTest', fedexSetting)"
                          [dataCyAttribute]="'companyCarrier-fedex-clientIdTest'"
                        ></form-row-input>
                        <form-row-input
                          [label]="'carrier.fedex.clientSecretTest'"
                          [icon]="null"
                          [model]="fedexSetting().clientSecretTest"
                          (modelChange)="settingsChanged($event, 'clientSecretTest', fedexSetting)"
                          [dataCyAttribute]="'companyCarrier-fedex-clientSecretTest'"
                        ></form-row-input>
                        <form-row-digits
                          [label]="'carrier.fedex.accountNumberTest'"
                          [requiredCssClass]="isFedexAccountNumberFormatInvalid(fedexSetting().accountNumberTest)"
                          [model]="fedexSetting().accountNumberTest"
                          (modelChange)="settingsChanged($event, 'accountNumberTest', fedexSetting)"
                          [errorLabel]="
                            isFedexAccountNumberFormatInvalid(fedexSetting().accountNumberTest)
                              ? 'carrier.fedex.accountNumber.invalid'
                              : null
                          "
                          [dataCyAttribute]="'companyCarrier-fedex-accountNumberTest'"
                        ></form-row-digits>
                      </div>
                      <div
                        class="settings-subsection"
                        role="group"
                        [attr.aria-label]="'carrier.fedex.trackSandbox' | translate"
                        data-cy="companyCarrier-fedex-trackSandbox"
                      >
                        <p class="font-weight-bold mb-1">{{ 'carrier.fedex.trackSandbox' | translate }}</p>
                        <!--                      <p class="text-muted small">{{ 'carrier.fedex.trackSandbox.hint' | translate }}</p>-->
                        <form-row-input
                          [label]="'carrier.fedex.trackClientIdTest'"
                          [requiredCssClass]="
                            submitted() &&
                            !isFedexTrackPairValid(
                              fedexSetting().trackClientIdTest,
                              fedexSetting().trackClientSecretTest
                            )
                          "
                          [icon]="null"
                          [model]="fedexSetting().trackClientIdTest"
                          (modelChange)="settingsChanged($event, 'trackClientIdTest', fedexSetting)"
                          [dataCyAttribute]="'companyCarrier-fedex-trackClientIdTest'"
                        ></form-row-input>
                        <form-row-input
                          [label]="'carrier.fedex.trackClientSecretTest'"
                          [requiredCssClass]="
                            submitted() &&
                            !isFedexTrackPairValid(
                              fedexSetting().trackClientIdTest,
                              fedexSetting().trackClientSecretTest
                            )
                          "
                          [icon]="null"
                          [model]="fedexSetting().trackClientSecretTest"
                          (modelChange)="settingsChanged($event, 'trackClientSecretTest', fedexSetting)"
                          [dataCyAttribute]="'companyCarrier-fedex-trackClientSecretTest'"
                        ></form-row-input>
                      </div>
                    </div>
                    <form-row-select
                      [label]="'carrier.fedex.termsOfSale'"
                      [icon]="null"
                      [model]="fedexSetting().termsOfSale"
                      (modelChange)="settingsChanged($event, 'termsOfSale', fedexSetting)"
                      [options]="fedexTermsOfSaleOptions"
                      [translationPrefix]="'carrier.fedex.termsOfSale.'"
                      [dataCyAttribute]="'companyCarrier-fedex-termsOfSale'"
                    ></form-row-select>
                    <form-row-input
                      [label]="'carrier.fedex.eori'"
                      [icon]="null"
                      [model]="fedexSetting().eori"
                      (modelChange)="settingsChanged($event, 'eori', fedexSetting)"
                      [dataCyAttribute]="'companyCarrier-fedex-eori'"
                    ></form-row-input>
                    <form-row-input
                      [label]="'carrier.fedex.productDesc'"
                      [requiredCssClass]="submitted() && fedexSetting().productDesc?.length > fedexProductDescMaxLength"
                      [icon]="null"
                      [model]="fedexSetting().productDesc"
                      (modelChange)="settingsChanged($event, 'productDesc', fedexSetting)"
                      [tooltipLabel]="'carrier.fedex.productDesc.hint'"
                      [dataCyAttribute]="'companyCarrier-fedex-productDesc'"
                    ></form-row-input>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'gls') {
                  <div>
                    <form-row-input
                      [label]="'username'"
                      [icon]="null"
                      [model]="glsSetting().username"
                      (modelChange)="settingsChanged($event, 'username', glsSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'password'"
                      [icon]="null"
                      [model]="glsSetting().password"
                      (modelChange)="settingsChanged($event, 'password', glsSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'carrier.gls.clientNumber'"
                      [icon]="null"
                      [model]="glsSetting().clientNumber"
                      (modelChange)="settingsChanged($event, 'clientNumber', glsSetting)"
                    ></form-row-input>
                    <form-row-checkbox
                      [label]="'myGls'"
                      [model]="glsSetting().myGls"
                      (modelChange)="settingsChanged($event, 'myGls', glsSetting)"
                    ></form-row-checkbox>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'ppl') {
                  <div>
                    <div class="padding-bottom-0-5">
                      <form-row-select
                        [icon]="null"
                        [model]="selectedPplOption()"
                        (modelChange)="selectedPplChanged($event)"
                        [options]="pplOptions"
                        [dataCyAttribute]="'isNewPplSelect'"
                      ></form-row-select>
                    </div>
                    @if (selectedPplOption() === 'oldPpl') {
                      <form-row-input
                        class="padding-top"
                        [label]="'username'"
                        [icon]="null"
                        [model]="oldPplSetting().username"
                        (modelChange)="settingsChanged($event, 'username', oldPplSetting)"
                        [dataCyAttribute]="'companyCarrier-username'"
                      ></form-row-input>
                      <!--                [requiredCssClass]="submitted() && !oldPplSetting().username"-->
                      <form-row-input
                        [label]="'password'"
                        [icon]="null"
                        [model]="oldPplSetting().password"
                        (modelChange)="settingsChanged($event, 'password', oldPplSetting)"
                        [dataCyAttribute]="'companyCarrier-password'"
                      ></form-row-input>
                      <!--                [requiredCssClass]="submitted() && !oldPplSetting().password"-->
                      <form-row-input
                        [label]="'carrier.customerId'"
                        [icon]="null"
                        [model]="oldPplSetting().customerId"
                        (modelChange)="settingsChanged($event, 'customerId', oldPplSetting)"
                        [dataCyAttribute]="'companyCarrier-customerId'"
                      ></form-row-input>
                      <!--                [requiredCssClass]="submitted() && !oldPplSetting().customerId"-->
                      <form-row-input
                        [label]="'depo'"
                        [icon]="null"
                        [model]="oldPplSetting().depo"
                        (modelChange)="settingsChanged($event, 'depo', oldPplSetting)"
                        [dataCyAttribute]="'companyCarrier-depo'"
                      ></form-row-input>
                      <!--                [requiredCssClass]="submitted() && !oldPplSetting().depo"-->
                      <div>
                        <div class="display-flex justify-content-between align-items-baseline">
                          <h3 class="card-title">{{ 'carrier.numberSequences' | translate }}</h3>
                          <btn
                            [label]="'add.row'"
                            [title]="'add.row' | translate"
                            [classes]="['btn-first']"
                            (onEvent)="addPplNumberRow()"
                          ></btn>
                        </div>
                        @for (n of oldPplSetting().numbersArr; track n) {
                          <div class="row">
                            <div class="col-5">
                              <!--                      todo brat z query nebo z formu???-->
                              <form-row-select
                                [label]="'tariff'"
                                [icon]="null"
                                [(model)]="n.tariffId"
                                [options]="tariffOptions()"
                                [optionKey]="'const'"
                                [dataCyAttribute]="'companyCarrier-tariffId'"
                              ></form-row-select>
                              <!--                      [requiredCssClass]="submitted() && !n.tariffId"-->
                            </div>
                            <div class="col-3">
                              <form-row-input
                                [label]="'date.from'"
                                [icon]="null"
                                [inputType]="'number'"
                                [(model)]="n.from"
                                [dataCyAttribute]="'companyCarrier-from'"
                              ></form-row-input>
                              <!--                      [requiredCssClass]="submitted() && !n.from"-->
                            </div>
                            <div class="col-3">
                              <form-row-input
                                [label]="'date.to'"
                                [icon]="null"
                                [inputType]="'number'"
                                [(model)]="n.to"
                                [dataCyAttribute]="'companyCarrier-to'"
                              ></form-row-input>
                              <!--                      [requiredCssClass]="submitted() && !n.to"-->
                            </div>
                            <div class="col-1 fix-vertical-align">
                              <btn
                                [icon]="'far-trash-alt'"
                                [title]="'delete' | translate"
                                [classes]="['btn-first-red', 'btn-sm']"
                                (onEvent)="removePplNumberRow(n)"
                              ></btn>
                            </div>
                          </div>
                        }
                      </div>
                    }
                    @if (selectedPplOption() === 'newPpl') {
                      <form-row-input
                        [label]="'username'"
                        [icon]="null"
                        [model]="newPplSetting().username"
                        (modelChange)="settingsChanged($event, 'username', newPplSetting)"
                        [dataCyAttribute]="'companyCarrier-username'"
                      ></form-row-input>
                      <!--                [requiredCssClass]="submitted() && !newPplSetting().username"-->
                      <form-row-input
                        [label]="'password'"
                        [icon]="null"
                        [model]="newPplSetting().password"
                        (modelChange)="settingsChanged($event, 'password', newPplSetting)"
                        [dataCyAttribute]="'companyCarrier-password'"
                      ></form-row-input>
                      <!--                [required]="true"-->
                      <!--                [requiredCssClass]="submitted() && !newPplSetting().password"-->
                    }
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'spring_xbs') {
                  <div>
                    <form-row-input
                      [label]="'carrier.apiKey'"
                      [icon]="null"
                      [model]="springXbsSetting().apikey"
                      (modelChange)="settingsChanged($event, 'apikey', springXbsSetting)"
                    ></form-row-input>
                    <!--              [requiredCssClass]="submitted() && !springXbsSetting().apikey"-->
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovnaSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovnaSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovnaSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovnaSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_dpd') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_dpdSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_dpdSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_dpdSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_dpdSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_be') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_beSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_beSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_beSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_beSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_cargus') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_cargusSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_cargusSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_cargusSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_cargusSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_cp') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_cpSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_cpSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_cpSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_cpSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_de_hermes_pp') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_de_hermes_ppSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_de_hermes_ppSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_de_hermes_ppSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_de_hermes_ppSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_de_hermes') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_de_hermesSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_de_hermesSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_de_hermesSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_de_hermesSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_dhl') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_dhlSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_dhlSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_dhlSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_dhlSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_es_mrw') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_es_mrwSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_es_mrwSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_es_mrwSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_es_mrwSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_es_mrw_hd') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_es_mrw_hdSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_es_mrw_hdSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_es_mrw_hdSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_es_mrw_hdSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_es_mrw_pp') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_es_mrw_ppSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_es_mrw_ppSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_es_mrw_ppSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_es_mrw_ppSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_es_correos') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_es_correosSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_es_correosSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_es_correosSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_es_correosSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_eo') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_eoSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_eoSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_eoSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_eoSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_fr_colissimo') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_fr_colissimoSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_fr_colissimoSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_fr_colissimoSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_fr_colissimoSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_cr_hr') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_cr_hrSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_cr_hrSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_cr_hrSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_cr_hrSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_hu_hd') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_hu_hdSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_hu_hdSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_hu_hdSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_hu_hdSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_ie_fastway') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_ie_fastwaySetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_ie_fastwaySetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_ie_fastwaySetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_ie_fastwaySetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_it') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_itSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_itSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_itSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_itSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_lu') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_luSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_luSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_luSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_luSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_mp') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_mpSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_mpSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_mpSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_mpSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_sk') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_skSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_skSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_skSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_skSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_nl_post') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_nl_postSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_nl_postSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_nl_postSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_nl_postSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_paczkomat') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_paczkomatSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_paczkomatSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_paczkomatSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_paczkomatSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_pl_hd') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_pl_hdSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_pl_hdSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_pl_hdSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_pl_hdSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_plpost') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_plpostSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_plpostSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_plpostSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_plpostSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_pt_mrw') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_pt_mrwSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_pt_mrwSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_pt_mrwSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_pt_mrwSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_at') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_atSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_atSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_atSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_atSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_si_post') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_si_postSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_si_postSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_si_postSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_si_postSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_sp') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_spSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_spSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_spSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_spSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_dk') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_dkSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_dkSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_dkSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_dkSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_gr_acs') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_gr_acsSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_gr_acsSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_gr_acsSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_gr_acsSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_gr_elta') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_gr_eltaSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_gr_eltaSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_gr_eltaSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_gr_eltaSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_gb_rm48') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_gb_rm48Setting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_gb_rm48Setting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_gb_rm48Setting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_gb_rm48Setting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_ch') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_chSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_chSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_chSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_chSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_se') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_seSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_seSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_seSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_seSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'zasilkovna_se_pp') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.eshop'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_se_ppSetting().eshop"
                          (modelChange)="settingsChanged($event, 'eshop', zasilkovna_se_ppSetting)"
                          data-cy="eshop"
                          [dataCyAttribute]="'eshop'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().eshop"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiPassword'"
                          [required]="true"
                          [icon]="null"
                          [model]="zasilkovna_se_ppSetting().api_password"
                          (modelChange)="settingsChanged($event, 'api_password', zasilkovna_se_ppSetting)"
                          data-cy="api-password"
                          [dataCyAttribute]="'api-password'"
                        ></form-row-input>
                        <!--                  [requiredCssClass]="submitted() && !zasilkovnaSetting().api_password"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'ulozenka') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.shopId'"
                          [required]="true"
                          [icon]="null"
                          [model]="ulozenkaSetting().shopId"
                          (modelChange)="settingsChanged($event, 'shopId', ulozenkaSetting)"
                        ></form-row-input>
                        <!--                    [requiredCssClass]="submitted() && !ulozenkaSetting().shopId"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiKey'"
                          [required]="true"
                          [icon]="null"
                          [model]="ulozenkaSetting().apiKey"
                          (modelChange)="settingsChanged($event, 'apiKey', ulozenkaSetting)"
                        ></form-row-input>
                        <!--                    [requiredCssClass]="submitted() && !ulozenkaSetting().apiKey"-->
                      </div>
                    </div>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'shippypro') {
                  <div>
                    <div class="row">
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.apiKey'"
                          [required]="true"
                          [icon]="null"
                          [model]="shippyproSetting().apikey"
                          (modelChange)="settingsChanged($event, 'apiKey', shippyproSetting)"
                        ></form-row-input>
                        <!--                    [requiredCssClass]="submitted() && !shippyproSetting().apikey"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'carrier.contentDescription'"
                          [required]="true"
                          [icon]="null"
                          [model]="shippyproSetting().contentDescription"
                          (modelChange)="settingsChanged($event, 'contentDescription', shippyproSetting)"
                        ></form-row-input>
                        <!--                    [requiredCssClass]="submitted() && !shippyproSetting().contentDescription"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'packageLength'"
                          [required]="true"
                          [icon]="null"
                          [inputType]="'number'"
                          [tooltipLabel]="'v centimetrech'"
                          [model]="shippyproSetting().packageLength"
                          (modelChange)="settingsChanged($event, 'packageLength', shippyproSetting)"
                        ></form-row-input>
                        <!--                    [requiredCssClass]="submitted() && !shippyproSetting().packageLength"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'packageWidth'"
                          [required]="true"
                          [icon]="null"
                          [inputType]="'number'"
                          [tooltipLabel]="'v centimetrech'"
                          [model]="shippyproSetting().packageWidth"
                          (modelChange)="settingsChanged($event, 'packageLength', shippyproSetting)"
                        ></form-row-input>
                        <!--                    [requiredCssClass]="submitted() && !shippyproSetting().packageWidth"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'packageHeight'"
                          [required]="true"
                          [icon]="null"
                          [inputType]="'number'"
                          [tooltipLabel]="'v centimetrech'"
                          [model]="shippyproSetting().packageHeight"
                          (modelChange)="settingsChanged($event, 'packageHeight', shippyproSetting)"
                        ></form-row-input>
                        <!--                    [requiredCssClass]="submitted() && !shippyproSetting().packageHeight"-->
                      </div>
                      <div class="col-12">
                        <form-row-input
                          [label]="'packageWeight'"
                          [required]="true"
                          [icon]="null"
                          [inputType]="'number'"
                          [tooltipLabel]="'v kilogramech'"
                          [model]="shippyproSetting().packageWeight"
                          (modelChange)="settingsChanged($event, 'packageWeight', shippyproSetting)"
                        ></form-row-input>
                        <!--                    [requiredCssClass]="submitted() && !shippyproSetting().packageWeight"-->
                      </div>
                    </div>
                  </div>
                }
                <!--            <div-->
                <!--              *ngIf="-->
                <!--                companyCarrierForm.value.carrier === 'wedo_home' ||-->
                <!--                companyCarrierForm.value.carrier === 'wedo_point' ||-->
                <!--                companyCarrierForm.value.carrier === 'wedo_box'-->
                <!--              "-->
                <!--            >-->
                <!--              <form-row-input-->
                <!--                [label]="'username'"-->
                <!--                [required]="true"-->
                <!--                [icon]="null"-->
                <!--                [model]="wedoSetting().username"-->
                <!--                (modelChange)="settingsChanged($event, 'username', wedoSetting)"-->
                <!--              ></form-row-input>-->
                <!--              &lt;!&ndash;                [requiredCssClass]="submitted() && !wedoSetting().username"&ndash;&gt;-->
                <!--              <form-row-input-->
                <!--                [label]="'password'"-->
                <!--                [required]="true"-->
                <!--                [icon]="null"-->
                <!--                [model]="wedoSetting().password"-->
                <!--                (modelChange)="settingsChanged($event, 'password', wedoSetting)"-->
                <!--              ></form-row-input>-->
                <!--              &lt;!&ndash;                [requiredCssClass]="submitted() && !wedoSetting().password"&ndash;&gt;-->
                <!--              <form-row-input-->
                <!--                [label]="'carrier.customerId'"-->
                <!--                [required]="true"-->
                <!--                [icon]="null"-->
                <!--                [model]="wedoSetting().customerId"-->
                <!--                (modelChange)="settingsChanged($event, 'customerId', wedoSetting)"-->
                <!--              ></form-row-input>-->
                <!--              &lt;!&ndash;                [requiredCssClass]="submitted() && !wedoSetting().customerId"&ndash;&gt;-->
                <!--              <form-row-input-->
                <!--                [label]="'department'"-->
                <!--                [required]="true"-->
                <!--                [icon]="null"-->
                <!--                [model]="wedoSetting().department"-->
                <!--                (modelChange)="settingsChanged($event, 'department', wedoSetting)"-->
                <!--              ></form-row-input>-->
                <!--              &lt;!&ndash;                [requiredCssClass]="submitted() && !wedoSetting().department"&ndash;&gt;-->
                <!--            </div>-->

                @if (companyCarrierForm.value.carrier === 'messenger') {
                  <div>
                    <form-row-input
                      [label]="'carrier.importKey'"
                      [required]="true"
                      [icon]="null"
                      [model]="messengerSetting().importKey"
                      (modelChange)="settingsChanged($event, 'importKey', messengerSetting)"
                    ></form-row-input>
                    <!--                [requiredCssClass]="submitted() && !messengerSetting().importKey"-->
                    <form-row-input
                      [label]="'username'"
                      [required]="true"
                      [icon]="null"
                      [model]="messengerSetting().username"
                      (modelChange)="settingsChanged($event, 'username', messengerSetting)"
                    ></form-row-input>
                    <!--                [requiredCssClass]="submitted() && !messengerSetting().username"-->
                    <form-row-input
                      [label]="'password'"
                      [required]="true"
                      [icon]="null"
                      [model]="messengerSetting().password"
                      (modelChange)="settingsChanged($event, 'password', messengerSetting)"
                    ></form-row-input>
                    <!--                [requiredCssClass]="submitted() && !messengerSetting().password"-->
                    <form-row-input
                      [label]="'carrier.contactPerson'"
                      [required]="true"
                      [icon]="null"
                      [model]="messengerSetting().contactPerson"
                      (modelChange)="settingsChanged($event, 'contactPerson', messengerSetting)"
                    ></form-row-input>
                    <!--                [requiredCssClass]="submitted() && !messengerSetting().contactPerson"-->
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'ups') {
                  <div>
                    <form-row-input
                      [label]="'carrier.accountNumber'"
                      [required]="true"
                      [icon]="null"
                      [model]="upsSetting().accountNumber"
                      (modelChange)="settingsChanged($event, 'accountNumber', upsSetting)"
                    ></form-row-input>
                    <!--                [requiredCssClass]="submitted() && !upsSetting().accountNumber"-->
                    <form-row-input
                      [label]="'username'"
                      [required]="true"
                      [icon]="null"
                      [model]="upsSetting().username"
                      (modelChange)="settingsChanged($event, 'username', upsSetting)"
                    ></form-row-input>
                    <!--                [requiredCssClass]="submitted() && !upsSetting().username"-->
                    <form-row-input
                      [label]="'password'"
                      [required]="true"
                      [icon]="null"
                      [model]="upsSetting().password"
                      (modelChange)="settingsChanged($event, 'password', upsSetting)"
                    ></form-row-input>
                    <!--                [requiredCssClass]="submitted() && !upsSetting().password"-->
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'sps') {
                  <div>
                    <form-row-input
                      [label]="'username'"
                      [required]="true"
                      [icon]="null"
                      [model]="spsSetting().username"
                      (modelChange)="settingsChanged($event, 'username', spsSetting)"
                    ></form-row-input>
                    <!--                [requiredCssClass]="submitted() && !spsSetting().username"-->
                    <form-row-input
                      [label]="'password'"
                      [required]="true"
                      [icon]="null"
                      [model]="spsSetting().password"
                      (modelChange)="settingsChanged($event, 'password', spsSetting)"
                    ></form-row-input>
                    <!--                [requiredCssClass]="submitted() && !spsSetting().password"-->
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'distribox') {
                  <div>
                    <form-row-input
                      [label]="'carrier.partnerCode'"
                      [required]="true"
                      [icon]="null"
                      [model]="distriboxSetting().partnerCode"
                      (modelChange)="settingsChanged($event, 'partnerCode', distriboxSetting)"
                    ></form-row-input>
                    <!--                [requiredCssClass]="submitted() && !distriboxSetting().partnerCode"-->
                    <form-row-input
                      [label]="'carrier.bearerToken'"
                      [required]="true"
                      [icon]="null"
                      [model]="distriboxSetting().bearerToken"
                      (modelChange)="settingsChanged($event, 'bearerToken', distriboxSetting)"
                    ></form-row-input>
                    <!--                [requiredCssClass]="submitted() && !distriboxSetting().bearerToken"-->
                    <form-row-input
                      [label]="'carrier.duration'"
                      [required]="true"
                      [icon]="null"
                      [model]="distriboxSetting().duration"
                      (modelChange)="settingsChanged($event, 'duration', distriboxSetting)"
                    ></form-row-input>
                    <!--                [requiredCssClass]="submitted() && !distriboxSetting().duration"-->
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'geis') {
                  <div>
                    <form-row-input
                      [label]="'username'"
                      [required]="true"
                      [icon]="null"
                      [model]="geisSetting().CustomerCode"
                      (modelChange)="settingsChanged($event, 'CustomerCode', geisSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'password'"
                      [required]="true"
                      [icon]="null"
                      [model]="geisSetting().password"
                      (modelChange)="settingsChanged($event, 'password', geisSetting)"
                    ></form-row-input>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'toptrans') {
                  <div>
                    <form-row-input
                      [label]="'username'"
                      [required]="true"
                      [icon]="null"
                      [model]="toptransSetting().username"
                      (modelChange)="settingsChanged($event, 'username', toptransSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'password'"
                      [required]="true"
                      [icon]="null"
                      [model]="toptransSetting().password"
                      (modelChange)="settingsChanged($event, 'password', toptransSetting)"
                    ></form-row-input>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === '123kuryr') {
                  <div>
                    <form-row-input
                      [label]="'username'"
                      [required]="true"
                      [icon]="null"
                      [model]="numberskuryrSetting().username"
                      (modelChange)="settingsChanged($event, 'username', numberskuryrSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'password'"
                      [required]="true"
                      [icon]="null"
                      [model]="numberskuryrSetting().password"
                      (modelChange)="settingsChanged($event, 'password', numberskuryrSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'carrier.addressId'"
                      [required]="true"
                      [icon]="null"
                      [model]="numberskuryrSetting().addressId"
                      (modelChange)="settingsChanged($event, 'addressId', numberskuryrSetting)"
                    ></form-row-input>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'baselinker') {
                  <div>
                    <!--              todo-->
                    <form-row-input
                      [label]="'carrier.shop'"
                      [required]="true"
                      [icon]="null"
                      [model]="baselinkerSetting().shop"
                      (modelChange)="settingsChanged($event, 'shop', baselinkerSetting)"
                    ></form-row-input>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'fofr') {
                  <div>
                    <form-row-input
                      [label]="'carrier.companyId'"
                      [required]="true"
                      [icon]="null"
                      [model]="fofrSetting().companyId"
                      (modelChange)="settingsChanged($event, 'companyId', fofrSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'carrier.branchCode'"
                      [required]="true"
                      [icon]="null"
                      [model]="fofrSetting().branchCode"
                      (modelChange)="settingsChanged($event, 'branchCode', fofrSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'username'"
                      [required]="true"
                      [icon]="null"
                      [model]="fofrSetting().username"
                      (modelChange)="settingsChanged($event, 'username', fofrSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'accountNumber'"
                      [required]="true"
                      [icon]="null"
                      [model]="fofrSetting().accountNumber"
                      (modelChange)="settingsChanged($event, 'accountNumber', fofrSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'accountBank'"
                      [required]="true"
                      [icon]="null"
                      [model]="fofrSetting().accountBank"
                      (modelChange)="settingsChanged($event, 'accountBank', fofrSetting)"
                    ></form-row-input>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'intime') {
                  <div>
                    <form-row-input
                      [label]="'username'"
                      [required]="true"
                      [icon]="null"
                      [model]="intimeSetting().username"
                      (modelChange)="settingsChanged($event, 'username', intimeSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'password'"
                      [required]="true"
                      [icon]="null"
                      [model]="intimeSetting().password"
                      (modelChange)="settingsChanged($event, 'password', intimeSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'customer'"
                      [required]="true"
                      [icon]="null"
                      [model]="intimeSetting().customer"
                      (modelChange)="settingsChanged($event, 'customer', intimeSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'carrier.department'"
                      [required]="true"
                      [icon]="null"
                      [model]="intimeSetting().department"
                      (modelChange)="settingsChanged($event, 'department', intimeSetting)"
                    ></form-row-input>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'shippypro_dhl') {
                  <div>
                    <form-row-input
                      [label]="'carrier.apiKey'"
                      [required]="true"
                      [icon]="null"
                      [model]="shippypro_dhlSetting().apikey"
                      (modelChange)="settingsChanged($event, 'apikey', shippypro_dhlSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'contentDescription'"
                      [required]="true"
                      [icon]="null"
                      [model]="shippypro_dhlSetting().contentDescription"
                      (modelChange)="settingsChanged($event, 'contentDescription', shippypro_dhlSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'packageLength'"
                      [required]="true"
                      [icon]="null"
                      [model]="shippypro_dhlSetting().packageLength"
                      (modelChange)="settingsChanged($event, 'packageLength', shippypro_dhlSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'packageWidth'"
                      [required]="true"
                      [icon]="null"
                      [model]="shippypro_dhlSetting().packageWidth"
                      (modelChange)="settingsChanged($event, 'packageWidth', shippypro_dhlSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'packageHeight'"
                      [required]="true"
                      [icon]="null"
                      [model]="shippypro_dhlSetting().packageHeight"
                      (modelChange)="settingsChanged($event, 'packageHeight', shippypro_dhlSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'packageWeight'"
                      [required]="true"
                      [icon]="null"
                      [model]="shippypro_dhlSetting().packageWeight"
                      (modelChange)="settingsChanged($event, 'packageWeight', shippypro_dhlSetting)"
                    ></form-row-input>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'shippypro_fedex') {
                  <div>
                    <form-row-input
                      [label]="'carrier.apiKey'"
                      [required]="true"
                      [icon]="null"
                      [model]="shippypro_fedexSetting().apikey"
                      (modelChange)="settingsChanged($event, 'apikey', shippypro_fedexSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'contentDescription'"
                      [required]="true"
                      [icon]="null"
                      [model]="shippypro_fedexSetting().contentDescription"
                      (modelChange)="settingsChanged($event, 'contentDescription', shippypro_fedexSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'packageLength'"
                      [required]="true"
                      [icon]="null"
                      [model]="shippypro_fedexSetting().packageLength"
                      (modelChange)="settingsChanged($event, 'packageLength', shippypro_fedexSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'packageWidth'"
                      [required]="true"
                      [icon]="null"
                      [model]="shippypro_fedexSetting().packageWidth"
                      (modelChange)="settingsChanged($event, 'packageWidth', shippypro_fedexSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'packageHeight'"
                      [required]="true"
                      [icon]="null"
                      [model]="shippypro_fedexSetting().packageHeight"
                      (modelChange)="settingsChanged($event, 'packageHeight', shippypro_fedexSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'packageWeight'"
                      [required]="true"
                      [icon]="null"
                      [model]="shippypro_fedexSetting().packageWeight"
                      (modelChange)="settingsChanged($event, 'packageWeight', shippypro_fedexSetting)"
                    ></form-row-input>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'shippypro_spring') {
                  <div>
                    <form-row-input
                      [label]="'carrier.apiKey'"
                      [required]="true"
                      [icon]="null"
                      [model]="shippypro_springSetting().apikey"
                      (modelChange)="settingsChanged($event, 'apikey', shippypro_springSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'contentDescription'"
                      [required]="true"
                      [icon]="null"
                      [model]="shippypro_springSetting().contentDescription"
                      (modelChange)="settingsChanged($event, 'contentDescription', shippypro_springSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'packageLength'"
                      [required]="true"
                      [icon]="null"
                      [model]="shippypro_springSetting().packageLength"
                      (modelChange)="settingsChanged($event, 'packageLength', shippypro_springSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'packageWidth'"
                      [required]="true"
                      [icon]="null"
                      [model]="shippypro_springSetting().packageWidth"
                      (modelChange)="settingsChanged($event, 'packageWidth', shippypro_springSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'packageHeight'"
                      [required]="true"
                      [icon]="null"
                      [model]="shippypro_springSetting().packageHeight"
                      (modelChange)="settingsChanged($event, 'packageHeight', shippypro_springSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'packageWeight'"
                      [required]="true"
                      [icon]="null"
                      [model]="shippypro_springSetting().packageWeight"
                      (modelChange)="settingsChanged($event, 'packageWeight', shippypro_springSetting)"
                    ></form-row-input>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'shippypro_swisspost') {
                  <div>
                    <form-row-input
                      [label]="'carrier.apiKey'"
                      [required]="true"
                      [icon]="null"
                      [model]="shippypro_swisspostSetting().apikey"
                      (modelChange)="settingsChanged($event, 'apikey', shippypro_swisspostSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'contentDescription'"
                      [required]="true"
                      [icon]="null"
                      [model]="shippypro_swisspostSetting().contentDescription"
                      (modelChange)="settingsChanged($event, 'contentDescription', shippypro_swisspostSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'packageLength'"
                      [required]="true"
                      [icon]="null"
                      [model]="shippypro_swisspostSetting().packageLength"
                      (modelChange)="settingsChanged($event, 'packageLength', shippypro_swisspostSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'packageWidth'"
                      [required]="true"
                      [icon]="null"
                      [model]="shippypro_swisspostSetting().packageWidth"
                      (modelChange)="settingsChanged($event, 'packageWidth', shippypro_swisspostSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'packageHeight'"
                      [required]="true"
                      [icon]="null"
                      [model]="shippypro_swisspostSetting().packageHeight"
                      (modelChange)="settingsChanged($event, 'packageHeight', shippypro_swisspostSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'packageWeight'"
                      [required]="true"
                      [icon]="null"
                      [model]="shippypro_swisspostSetting().packageWeight"
                      (modelChange)="settingsChanged($event, 'packageWeight', shippypro_swisspostSetting)"
                    ></form-row-input>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'ulozenka_cp') {
                  <div>
                    <form-row-input
                      [label]="'carrier.apiKey'"
                      [required]="true"
                      [icon]="null"
                      [model]="ulozenka_cpSetting().apiKey"
                      (modelChange)="settingsChanged($event, 'apiKey', ulozenka_cpSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'carrier.shopId'"
                      [required]="true"
                      [icon]="null"
                      [model]="ulozenka_cpSetting().shopId"
                      (modelChange)="settingsChanged($event, 'shopId', ulozenka_cpSetting)"
                    ></form-row-input>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'ulozenka_dpd') {
                  <div>
                    <form-row-input
                      [label]="'carrier.apiKey'"
                      [required]="true"
                      [icon]="null"
                      [model]="ulozenka_dpdSetting().apiKey"
                      (modelChange)="settingsChanged($event, 'apiKey', ulozenka_dpdSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'carrier.shopId'"
                      [required]="true"
                      [icon]="null"
                      [model]="ulozenka_dpdSetting().shopId"
                      (modelChange)="settingsChanged($event, 'shopId', ulozenka_dpdSetting)"
                    ></form-row-input>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'wedo_box') {
                  <div>
                    <form-row-input
                      [label]="'username'"
                      [required]="true"
                      [icon]="null"
                      [model]="wedo_boxSetting().username"
                      (modelChange)="settingsChanged($event, 'username', wedo_boxSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'password'"
                      [required]="true"
                      [icon]="null"
                      [model]="wedo_boxSetting().password"
                      (modelChange)="settingsChanged($event, 'password', wedo_boxSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'customer'"
                      [required]="true"
                      [icon]="null"
                      [model]="wedo_boxSetting().customer"
                      (modelChange)="settingsChanged($event, 'customer', wedo_boxSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'carrier.pickupPlaceCode'"
                      [required]="true"
                      [icon]="null"
                      [model]="wedo_boxSetting().pickupPlaceCode"
                      (modelChange)="settingsChanged($event, 'pickupPlaceCode', wedo_boxSetting)"
                    ></form-row-input>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'wedo_home') {
                  <div>
                    <form-row-input
                      [label]="'username'"
                      [required]="true"
                      [icon]="null"
                      [model]="wedo_homeSetting().username"
                      (modelChange)="settingsChanged($event, 'username', wedo_homeSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'password'"
                      [required]="true"
                      [icon]="null"
                      [model]="wedo_homeSetting().password"
                      (modelChange)="settingsChanged($event, 'password', wedo_homeSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'customer'"
                      [required]="true"
                      [icon]="null"
                      [model]="wedo_homeSetting().customer"
                      (modelChange)="settingsChanged($event, 'customer', wedo_homeSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'pickupPlaceCode'"
                      [required]="true"
                      [icon]="null"
                      [model]="wedo_homeSetting().pickupPlaceCode"
                      (modelChange)="settingsChanged($event, 'pickupPlaceCode', wedo_homeSetting)"
                    ></form-row-input>
                  </div>
                }
                @if (companyCarrierForm.value.carrier === 'wedo_point') {
                  <div>
                    <form-row-input
                      [label]="'username'"
                      [required]="true"
                      [icon]="null"
                      [model]="wedo_pointSetting().username"
                      (modelChange)="settingsChanged($event, 'username', wedo_pointSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'password'"
                      [required]="true"
                      [icon]="null"
                      [model]="wedo_pointSetting().password"
                      (modelChange)="settingsChanged($event, 'password', wedo_pointSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'customer'"
                      [required]="true"
                      [icon]="null"
                      [model]="wedo_pointSetting().customer"
                      (modelChange)="settingsChanged($event, 'customer', wedo_pointSetting)"
                    ></form-row-input>
                    <form-row-input
                      [label]="'pickupPlaceCode'"
                      [required]="true"
                      [icon]="null"
                      [model]="wedo_pointSetting().pickupPlaceCode"
                      (modelChange)="settingsChanged($event, 'pickupPlaceCode', wedo_pointSetting)"
                    ></form-row-input>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </section>
    </form>
  }
</div>
